import {LIVE_REGION_TIMEOUT_MS} from '../constants';

const LiveRegion = document.querySelector('[data-kinde-live-region]');
const LiveRegionNames = {
    copyToClipboard: 'CopyToClipboard',
    copyToClipboardAlt: 'CopyToClipboardAlt',
    formLoading: 'FormLoading',
    formSubmit: 'FormSubmit'
};

const clearLiveRegion = () => (LiveRegion.textContent = null);

const getLiveRegion = (name) => {
    if (!LiveRegion) {
        return;
    }

    const dataAttrPrefix = 'kindeLiveRegion';
    const dataAttrName = `${dataAttrPrefix}${LiveRegionNames[name]}`;

    if (!dataAttrName) {
        console.warn(
            `Kinde: No live region data attribute matching: “${dataAttrName}”`
        );

        return;
    }

    return LiveRegion.dataset[dataAttrName];
};

const generateLiveRegion = (name, hasTimeout = false) => {
    const liveRegion = getLiveRegion(name);

    LiveRegion.textContent = liveRegion;

    if (hasTimeout) {
        setTimeout(() => {
            LiveRegion.textContent = null;
        }, LIVE_REGION_TIMEOUT_MS);
    }
};

export {generateLiveRegion, getLiveRegion, clearLiveRegion};
